
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["getRows","getRow","search","perform","putRow","pushEvents","sendEvent","exportObjectStoresData","importObjectStoresData"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "5fc8cdb208e594d8fc23.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			